const _Filter_Types = {
	Date_Range: "Date_Range",
	Checkbox: "Checkbox",
	Button: "Button",
	Input: "Input",
	Radio: "Radio",
	MINMAX: "MINMAX",
	Recursive: "recursive",
	Text: "Text"
};

export default _Filter_Types;
